module.exports = __webpack_public_path__ + "assets/img/BodyLux.860050c9.webp";